import { createFileRoute, redirect } from "@tanstack/react-router"
import { z } from "zod"

/** Comments live in the Inbox now; old links land on the same item in the comments view. */
export const Route = createFileRoute("/w/$workspace/comments")({
  validateSearch: z.object({ c: z.string().optional(), filter: z.enum(["all", "needs_reply", "replied", "done", "hidden"]).optional(), q: z.string().optional() }),
  beforeLoad: ({ params, search }) => {
    const view = search.filter === "needs_reply" ? "attention" : search.filter === "done" ? "done" : "all"
    throw redirect({ to: "/w/$workspace/inbox", params, search: { type: "comments", view, ...(search.filter === "hidden" ? { visibility: "hidden" as const } : {}), ...(search.c ? { c: search.c, k: "comment" as const } : {}), ...(search.q ? { q: search.q } : {}) }, replace: true })
  },
})
